module.exports = __webpack_public_path__ + "static/media/flutter_logo.adbdc925.png";